import * as signalR from '@microsoft/signalr';

let NotificationConnection = null;
const BASE_URL = process.env.REACT_APP_API_BASE_URL || "";

export const startNotificationConnection = async (role, userId) => {
  if (NotificationConnection) {
    return NotificationConnection;
  }

  const connection = new signalR.HubConnectionBuilder()
    .withUrl(
      `${BASE_URL.replace(/\/api$/, "")}/notificationHub?role=${role}&userId=${userId}`
    )
    .withAutomaticReconnect()
    .build();

  try {
    await connection.start();
    NotificationConnection = connection;
    return connection;
  } catch (err) {
    console.error('SignalR Connection Error:', err);
    throw err;
  }
};

export const getNotificationConnection = () => NotificationConnection;

export const stopNotificationConnection = async () => {
  if (NotificationConnection) {
    await NotificationConnection.stop();
    NotificationConnection = null;
  }
};
